import * as React from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import styles from './MasonryGrid.pcss'
import { GRID_BREAKPOINTS } from './types'

type MasonryGridProps = {
  className?: string
  breakpoints?: Record<number, number>
}

export function MasonryGrid({ className, breakpoints, children }: React.PropsWithChildren<MasonryGridProps>) {
  return (
    <ResponsiveMasonry columnsCountBreakPoints={breakpoints || GRID_BREAKPOINTS}>
      <Masonry gutter="12px" className={`${styles.masonry} ${className || ''}`}>
        {children}
      </Masonry>
    </ResponsiveMasonry>
  )
}
